export type AvailabilityOverviewCsvSectionId =
  'timeslots' | 'daysOfWeek' | 'backgroundCheck' | 'districts' | 'states' | 'seasonTotals';

export type AvailabilityOverviewDistrictsExport = 'ready' | 'pending' | 'error';

/** Drops the districts section until that request has finished, so a download does not include an empty table. */
export function availabilityOverviewCsvSectionIds(
  selectedIds: AvailabilityOverviewCsvSectionId[],
  districtsExport: AvailabilityOverviewDistrictsExport,
): AvailabilityOverviewCsvSectionId[] {
  if (districtsExport === 'ready' || !selectedIds.includes('districts')) {
    return selectedIds;
  }
  return selectedIds.filter((id) => id !== 'districts');
}
